"use strict";
var getMapData = require('./_getMapData');
function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;
//# sourceMappingURL=_mapCacheDelete.js.map